class UIWindow extends PIXI.Container {
	hide() {
	}

	update() {
	}
}